import React from 'react'
import {
  Box,
  Typography
} from '@mui/material'
import { SyncProgressBar } from './sync/SyncProgressBar'

interface SyncProgressDisplayProps {
  progress: number
  currentStep: string
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled'
  system?: 'lightspeed' | 'xero' | 'skimmer'
  showDetails?: boolean
  height?: number
}

export const SyncProgressDisplay: React.FC<SyncProgressDisplayProps> = ({
  progress,
  currentStep,
  status,
  system = 'lightspeed',
  showDetails = true,
  height = 8
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* Use the new SyncProgressBar component */}
      <SyncProgressBar
        progress={progress}
        currentStage={currentStep}
        system={system}
        variant={showDetails ? 'full' : 'compact'}
        showPercentage={true}
      />

      {/* Additional details */}
      {showDetails && status === 'running' && (
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ mt: 0.5, display: 'block' }}
        >
          {currentStep}
        </Typography>
      )}
    </Box>
  )
}

export default SyncProgressDisplay